var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadFile = function SvgDownloadFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2C5.12109 2 4 3.12109 4 4.5V19.5C4 20.8789 5.12109 22 6.5 22H16.5C17.8789 22 19 20.8789 19 19.5V8.25H14C13.3086 8.25 12.75 7.69141 12.75 7V2H6.5ZM14 2V7H19L14 2ZM12.4375 11.0625V15.0508L13.6484 13.8398C14.0156 13.4727 14.6094 13.4727 14.9727 13.8398C15.3359 14.207 15.3398 14.8008 14.9727 15.1641L12.1602 17.9766C11.793 18.3438 11.1992 18.3438 10.8359 17.9766L8.02344 15.1641C7.65625 14.7969 7.65625 14.2031 8.02344 13.8398C8.39062 13.4766 8.98437 13.4727 9.34766 13.8398L10.5586 15.0508V11.0625C10.5586 10.543 10.9766 10.125 11.4961 10.125C12.0156 10.125 12.4336 10.543 12.4336 11.0625H12.4375Z",
    fill: "#3A4052"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadFile.86a65053.svg";
export { ForwardRef as ReactComponent };